import styled from '@emotion/styled';
import { mediaQuery } from '@styles/index';
import UpscTopicContentBlockRenderer from './UpscTopicContentBlockRenderer';
import { UpscTopicContentBlock } from './upscCurrentAffairsTopicTypes';

const Section = styled.section`
  margin-bottom: 32px;

  &:last-of-type {
    margin-bottom: 0;
  }
`;

const SectionTitle = styled.h2`
  margin: 0 0 12px;
  font-size: 22px;
  font-weight: 700;
  line-height: 1.3;
  color: var(--color-text-primary);

  ${mediaQuery.uptoMobile} {
    font-size: 18px;
  }
`;

export interface UpscTopicContentBlocksListProps {
  contentBlocks: UpscTopicContentBlock[];
}

const UpscTopicContentBlocksList = ({
  contentBlocks
}: UpscTopicContentBlocksListProps) => (
  <>
    {contentBlocks.map((block, index) => (
      <Section
        key={block.id ?? `content-block-${index}`}
        aria-labelledby={
          block.label ? `upsc-content-block-${block.id ?? index}` : undefined
        }
      >
        {block.label ? (
          <SectionTitle id={`upsc-content-block-${block.id ?? index}`}>
            {block.label}
          </SectionTitle>
        ) : null}
        <UpscTopicContentBlockRenderer block={block} />
      </Section>
    ))}
  </>
);

export default UpscTopicContentBlocksList;
